
import React, { useEffect, useState, Children, useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import { Link } from "react-router-dom"
import Card from './Card'
import { getDate } from '../utils/getDate'
import FormatQuestionTitle from '../checklists/FormatQuestionTitle'
import { tableData } from '../tests/testTableData'

type Props = {
    historyItem: ObjectStringKeyAnyValue
}

function UpdateHistoryItem({
    historyItem
}: Props) {


    const {
        tableData
    } = useContext(GlobalContext)

    const question = historyItem['questionId'] && tableData && tableData.ChecklistQuestions && tableData.ChecklistQuestions[historyItem['questionId']]


    return <Card fullwidth={true}>


        <div className={`flex flex-col gap-1 text-xs`}>
            <p className={``}>📆 {getDate(historyItem['modified_at'], 'formattedDateAndTime')}</p>
            {historyItem && historyItem['lastModifiedBy'] &&
                <div className={`flex flex-row gap-2`}>
                    <p>
                        {historyItem['lastModifiedBy']['name'] || ''}
                        {historyItem['lastModifiedBy']['email'] && ` (${historyItem['lastModifiedBy']['email']}) `}
                        {historyItem['lastModifiedBy']['loginMethod'] && historyItem['lastModifiedBy']['loginMethod'] == 'cognito' ? 'Logged in user' : ''}
                    </p>
                    {historyItem['lastModifiedBy']['message'] && <p> {historyItem['lastModifiedBy']['message']}</p>}
                </div>}
        </div>


        <div className={`border-t-2 border-dashed border-gray-400 pt-4 flex flex-col gap-1`}>

            {question && <FormatQuestionTitle question={question} />}

            {historyItem['questionId'] && !question && <p className={`font-bold`}>Question Id: #{historyItem['questionId']}</p>}



            {/* <p className={`font-bold`}>Changes:  </p> */}
            {historyItem['changes'] && historyItem['changes'].length > 0 && <div className={`flex flex-col gap-2`}>
                {historyItem['changes'].map((thisChange: any, index: number) => {
                    return <div key={index} className={`flex flex-row gap-2`}>
                        <p className={``}>✏️</p>
                        <p className={``}>{thisChange}</p>
                    </div>
                })}
            </div>}

        </div>
    </Card>
}
export default UpdateHistoryItem